import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private toastCtrl: ToastController) {}

  async show(message: string, severity: string) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 2500,
      color: this.mapTypeToColor(severity),
    });

    await toast.present();
  }

  private mapTypeToColor(severity: string) {
    switch (severity) {
      case 'success':
        return 'success';
      case 'error':
        return 'danger';
      case 'warn':
        return 'warning';
      default:
        return 'primary';
    }
  }
}
